export function enumSelector(definition, keyFunction = null) {
    return Object.keys(definition)
        .map(key => ({ key: definition[key], text: !!keyFunction ? keyFunction(key) : key }));
}

export function enumNumberSelector(definition, keyFunction = null) {
    return Object.keys(definition).filter(key => !Number(key) && key !== '0')
        .reduce((a, k, i) => (a.push({ key: i, text: !!keyFunction ? keyFunction(k) : k }), a), []);
}